import {axios} from '@/utils'
import UserService from '@/services/User.js'
import metric_message from "@/domain/metrics/message";
import MessageManager from "@/domain/core/utils/messageManager";


const user = JSON.parse(localStorage.getItem('user')) || ''
if (user) {
    metric_message.setUserId(user.id)
    MessageManager.setUserId(user.id)
}

const state = {
    token: localStorage.getItem('token') || '',
    token_type: localStorage.getItem('token_type') || '',
    auth_method: localStorage.getItem('auth_method') || '',
    user: user
}

const getters = {
    isAuthenticated: state => !!state.token,
    hasAcceptedRequiredPolicies: state => !!state.user.accepted_required_policies,
    currentUser: state => state.user,
    isAnonymous: state => state.user && state.user.is_anonymous,
    isSsoUser: state => state.auth_method === 'sso',
    hasPerm: (state) => (perm) => state.user && state.user.perms && state.user.perms.indexOf(perm) !== -1,
    token: state => state.token,
    tokenType: state => state.token_type,
}

const mutations = {
    SET_TOKEN(state, {token, token_type, remember = true}) {
        state.token = token
        state.token_type = token_type
        axios.defaults.headers.common['Authorization'] = `${token_type} ${token}`
        if (remember) {
            localStorage.setItem('token', token)
            localStorage.setItem('token_type', token_type)
        }
    },

    SET_AUTH_METHOD(state, auth_method) {
        state.auth_method = auth_method
        localStorage.setItem('auth_method', auth_method)
    },

    SET_USER(state, {user, remember = true}) {
        state.user = user
        metric_message.setUserId(user.id)
        MessageManager.setUserId(user.id)
        if (remember)
            localStorage.setItem('user', JSON.stringify(user))
    },

    LOGOUT(state) {
        state.token = ''
        state.token_type = ''
        state.auth_method = ''
        state.user = ''
        this.commit('CLEAR_CUSTOM_MODAL_CHECKIN_DETAIL_SHOWN', null, {root: true})
        this.commit('checkinDetail/clean_popup_viewed')
        metric_message.setUserId(null)
        MessageManager.setUserId(null)
        localStorage.removeItem('token')
        localStorage.removeItem('token_type')
        localStorage.removeItem('auth_method')
        localStorage.removeItem('user')
        localStorage.removeItem('eventOwnerId')
        localStorage.removeItem('customModalCheckinDetailShown')
        sessionStorage.removeItem('recover_picacode')
        sessionStorage.removeItem('auto-retry-checkin')
        delete axios.defaults.headers.common['Authorization']
        delete axios.defaults.headers.common['Pica-Event-Owner-Id']
    },
}


const actions = {
    login({commit}, user) {
        return new Promise((resolve, reject) => {
            UserService.getAuthToken(user.email, user.password)
                .then(response => {
                    commit('SET_TOKEN', {
                        token: response.data.token,
                        token_type: 'Token'
                    })
                    commit('SET_AUTH_METHOD', 'password')
                    resolve(response)
                })
                .catch(error => {
                    commit('LOGOUT')
                    reject(error)
                })
        })
    },

    loginWithJwt({commit}, token) {
        commit('SET_TOKEN', {
            token: token,
            token_type: 'Bearer'
        })
        commit('SET_AUTH_METHOD', 'jwt')
    },

    ssoLogin({commit}, {integration_id, token}) {
        return new Promise((resolve, reject) => {
            UserService.getTokenFromSsoLogin(integration_id, token).then(response => {
                commit('SET_TOKEN', {
                    token: response.data.token,
                    token_type: 'Token'
                })
                commit('SET_AUTH_METHOD', 'sso')
                resolve(response.data)
            }).catch(error => {
                commit('LOGOUT')
                reject(error)
            })
        })
    },

    socialLogin({commit, state}, data) {
        return new Promise((resolve, reject) => {
            const tokenBeforeLogin = state.token

            UserService.convertAuthToken(data).then(response => {
                commit('SET_TOKEN', {
                    token: response.data.access_token,
                    token_type: response.data.token_type
                })
                commit('SET_AUTH_METHOD', 'social')
                resolve(response)
            }).catch(error => {
                // A concurrent login may have succeeded in the meantime (e.g. double click
                // on a social button): its session must survive this failed attempt
                if (state.token === tokenBeforeLogin) commit('LOGOUT')
                reject(error)
            })
        })
    },

    ibiLogin({commit}, data) {
        return new Promise((resolve, reject) => {
            UserService.convertIbiAuthToken(data).then(response => {
                commit('SET_TOKEN',  {
                    token: response.data.access_token,
                    token_type: response.data.token_type
                })
                commit('SET_AUTH_METHOD', 'ibi')
                resolve(response)
            }).catch(error => {
                commit('LOGOUT')
                reject(error)
            })
        })
    },


    getCurrentUser({commit}, remember = true) {
        return UserService.getUserData()
            .then(response => {
                const user = response.data
                commit('SET_USER', {
                    user: user,
                    remember: remember
                })
                return response
            })
            .catch(function (error) {
                // console.log(error)
                return error
            })
    },

    logout({commit}) {
        return new Promise((resolve) => {
            commit('LOGOUT')
            resolve()
        })
    }
}


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}